<template>
  <vs-row class="temp-document-alert">
    <div class="glassmorphism-container">
      <div class="message-wrapper">
        <div class="icon-container">
          <i class="material-icons animated-icon">description</i>
        </div>
        <div class="message-container">
          <h4 class="status-title">임시저장 문서</h4>
          <p v-if="isWriter" class="status-description">결재 절차를 시작하려면 '결재품의' 버튼을 클릭해주세요.</p>
          <p v-else class="status-description">현재 임시저장 상태의 문서입니다. 작성자의 결재품의 후 결재가 가능합니다.</p>
        </div>
      </div>
      <div class="action-container" v-if="isWriter">
        <vs-button class="w-full" color="secondary" @click="handleClickUpload">결재품의</vs-button>
      </div>
    </div>
  </vs-row>
</template>

<script>
export default {
  name: 'TempDocumentAlert',
  props: {
    isWriter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClickUpload() {
      this.$emit('click-upload');
    }
  }
}
</script>

<style scoped>
.temp-document-alert {
  margin: 0 0 1.5rem;
  border-radius: 12px;
  overflow: hidden;
}

.glassmorphism-container {
  background: rgba(0, 0, 0, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 1.0rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.message-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 193, 7, 0.1);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.animated-icon {
  color: #FFC107;
  font-size: 24px;
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.message-container {
  flex-grow: 1;
}

.status-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.status-description {
  font-size: 14px;
  color: #666;
  margin: 0;
  word-break: keep-all;
}

.action-container {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

.continue-button {
  border-radius: 8px;
  padding: 0.5rem 1.25rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.button-text {
  font-weight: 500;
}
</style>
